import { fetcher } from "utils";

import { StoreDetailSerialized } from "typings";

type GetStoresId = (id: number | string) => Promise<StoreDetailSerialized>;

export const get__stores__id: GetStoresId = id => fetcher.get(`/stores/${id}`);
